import { TextAppearanceKeys, TextEmphasisKeys, TextSizeKeys } from '@/constants/enum';

export const textSizes = [
  {
    id: TextSizeKeys.base,
    name: 'Base',
    fontSize: 'var(--typography-font-size-base, 14px)',
  },
  {
    id: TextSizeKeys.extraSmall,
    name: 'Extra small',
    fontSize: 'var(--typography-font-size-extra-small, 10px)',
  },
  {
    id: TextSizeKeys.small,
    name: 'Small',
    fontSize: 'var(--typography-font-size-small, 12px)',
  },
  {
    id: TextSizeKeys.medium,
    name: 'Medium',
    fontSize: 'var(--typography-font-size-medium, 16px)',
  },
  {
    id: TextSizeKeys.large,
    name: 'Large',
    fontSize: 'var(--typography-font-size-large, 19px)',
  },
  {
    id: TextSizeKeys.extraLarge,
    name: 'Extra large',
    fontSize: 'var(--typography-font-size-extra-large, 21px)',
  },
];

export const textAppereances = [
  {
    id: TextAppearanceKeys.base,
    name: 'Base',
    color: undefined,
  },
  {
    id: TextAppearanceKeys.accent,
    name: 'Accent',
    color: 'var(--base-accent, #197CBD)',
  },
  {
    id: TextAppearanceKeys.critical,
    name: 'Critical',
    color: 'var(--critical-critical, #DD1D1D)',
  },
  {
    id: TextAppearanceKeys.decorative,
    name: 'Deco',
    color: 'var(--base-decorative, #1773B0)',
  },
  {
    id: TextAppearanceKeys.info,
    name: 'Info',
    color: 'var(--info-info, #000)',
  },
  {
    id: TextAppearanceKeys.subdue,
    name: 'Subdue',
    color: 'var(--base-textSubdued, #707070)',
  },
  {
    id: TextAppearanceKeys.success,
    name: 'Success',
    color: 'var(--success-success, #4D7A50)',
  },
  {
    id: TextAppearanceKeys.warning,
    name: 'Warning',
    color: 'var(--warning-warning, #8F6900)',
  },
];

export const textEmphasis = [
  {
    id: TextEmphasisKeys.base,
    name: 'Default',
    style: undefined,
  },
  {
    id: TextEmphasisKeys.bold,
    name: 'Bold',
    style: 'bold',
  },
  {
    id: TextEmphasisKeys.italic,
    name: 'Italic',
    style: 'italic',
  },
];
